import React, { Component } from "react";
import styles from "./index.module.scss";
import VideoWrapper from "./components/VideoWrapper";
import axios from "@/util/axios";
import { api } from "@/routes/api";
import { connect } from 'react-redux';
import { changeLoading } from '@/redux/base.redux';

const { getVideoList } = api;

@connect(
  null,
  { changeLoading }
)
class Index extends Component {

  state = {
    newVideoList: [],
    hotVideoList: [],
    newSelectItem: {}
  };

  async componentDidMount() {
    this.props.changeLoading(true);
    const res = await axios.post(getVideoList, { page: 1, limit: 1000 });
    if (res.code === 0) {
      const newVideoList = res.data.data.filter(item => item.type === 1);
      const hotVideoList = res.data.data.filter(item => item.type === 2);
      this.setState({ newVideoList, hotVideoList, ambulance: res.ambulance, newSelectItem: newVideoList[0], hotSelectItem: hotVideoList[0] });
    }
    setTimeout(() => this.props.changeLoading(false), 500);
  }

  handleSelectNewVideo = (item) => {
    this.setState({ newSelectItem: item })
  }
  handleSelectHotVideo = (item) => {
    this.setState({ hotSelectItem: item })
  }

  render() {
    const { newVideoList, hotVideoList, newSelectItem, hotSelectItem, ambulance } = this.state;
    const newVideoInfo = { title: "萌新上线", second_title: "新品茶器美物 款款动人心弦" };
    const hotVideoInfo = { title: "销量榜单", second_title: "高颜值实力派 圈粉一众茶友" };
    return (
      <div>
        <div className={`${styles.banner} ${styles.top_banner}`}>
          <img
            className={styles.banner_img}
            src="/images/top_banner.jpg"
            alt="banner"
          />
        </div>
        <div className={styles.video_wrapper}>
          <VideoWrapper style={{ flexDirection: "row-reverse" }} handleSelectVideo={this.handleSelectNewVideo} ambulance={ambulance} videoList={newVideoList} info={newVideoInfo} selectedItem={newSelectItem} />
        </div>
        <div className={styles.middle_text}>Video Album</div>
        <div className={styles.video_wrapper}>
          <VideoWrapper style={{ flexDirection: "row" }} handleSelectVideo={this.handleSelectHotVideo} ambulance={ambulance} videoList={hotVideoList} info={hotVideoInfo} selectedItem={hotSelectItem} />
        </div>
        <div style={{ marginBottom: 105 }}></div>
        <div className={styles.app_footer}>
          <div className={styles.app_img_container}>
            <img src="/images/logo.png" alt=""/>
          </div>
          <div className={styles.app_info_container}>
            <div className={styles.app_info}>
              <div>杭州雅集茶具有限公司</div>
              <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
            </div>
            <div className={styles.app_info}>
              <div>雅集专线:0571-86551555</div>
              <div>浙公网安备 33010802004971号</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
